// Poll Management Admin Page
// Wrapper for the PollAdminPanel component

import React from 'react';
import PollAdminPanel from '../../components/admin/PollAdminPanel';

const PollManagement = () => {
  return <PollAdminPanel />;
};

export default PollManagement;
